import { z } from 'zod';
import { VersandStatus } from './nutzer';
import { PlattformLevelSchema } from './plattformLevel';

/** Nutzer der DXL-Plattform (Rolle dxl_admin, ohne Marktplatz) mit Rechte-Level */
export const PlattformNutzerZeile = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string(),
  aktiv: z.boolean(),
  level: PlattformLevelSchema,
  /** Einladung verschickt, aber noch kein Passwort gesetzt */
  einladungOffen: z.boolean(),
  zweiFaktor: z.boolean(),
  gesperrtDurchVersuche: z.boolean(),
  letzteAnmeldung: z.string().nullable(),
  erstelltAm: z.string(),
});
export type PlattformNutzerZeile = z.infer<typeof PlattformNutzerZeile>;

export const PlattformNutzerEinladenSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120),
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
  level: PlattformLevelSchema.default('administrator'),
});
export type PlattformNutzerEinladen = z.infer<typeof PlattformNutzerEinladenSchema>;

export const PlattformNutzerAendernSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120).optional(),
  aktiv: z.boolean().optional(),
  level: PlattformLevelSchema.optional(),
});
export type PlattformNutzerAendern = z.infer<typeof PlattformNutzerAendernSchema>;

export interface PlattformEinladungErgebnis {
  nutzer: PlattformNutzerZeile;
  link: string;
  versand: z.infer<typeof VersandStatus>;
}

/** Betriebsart der Plattform (nur Anzeige) */
export interface PlattformBetrieb {
  art: 'mandantenfaehig';
  marktplaetze: { gesamt: number; aktiv: number; eingeladen: number; gesperrt: number };
  plattformNutzer: number;
  version: string;
  commit: string | null;
  region: string | null;
  app: string | null;
  umgebung: 'development' | 'test' | 'production';
}
